import { Link, Outlet, useSearchParams } from 'react-router-dom'
import { Logo } from 'components/common'
import { usePageTracking } from 'hooks/use-page-tracking'
import { useStore } from 'hooks/useStore'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export function AuthLayout() {
	usePageTracking()
	const { loadingLogout } = useStore()
	const [searchParams] = useSearchParams()
	const redirectTo = searchParams.get('to')

	return (
		<div className="h-screen">
			<div className="min-h-full flex flex-col items-center justify-center px-4 xs:px-8 py-8">
				<div className="mb-8 -ml-7">
					<a href={import.meta.env.VITE_LANDING_URL}>
						<Logo height={48} variant="full" />
					</a>
				</div>
				<div className="w-full max-w-md rounded-2xl border border-translucent-border bg-secondary-surface/[0.3] backdrop-blur-lg p-6 xs:p-8">
					<Outlet />
				</div>
				{redirectTo && (
					<div className="mt-4 text-center">
						<Link
							to={redirectTo}
							className="text-sm text-secondary-text hover:text-primary-text transition-colors"
						>
							← Go back to where you were
						</Link>
					</div>
				)}
			</div>
			{loadingLogout && (
				<div className="flex justify-center items-center py-4 size-full fixed top-0 left-0 bg-primary-surface/[0.4] backdrop-blur-lg bg-opacity-90 z-[9999]">
					<FontAwesomeIcon icon={['fas', 'spinner']} size="2x" spin className="text-white" />
				</div>
			)}
		</div>
	)
}
